import { HomepageFeaturedCollectionsData } from '../../../types/hooks/getHomepageFeaturedCollections';
import { QueryParams } from '../../../types/api/BasicTypes';
import { GenericResponse } from '../../../types/api/Http';
import { CollectionResponse } from '../../../types/api/CollectionsIndexTypes';
import { AxiosError } from 'axios';

import axios from 'axios';
import { touchCookie } from '../../../helpers/analytics/userInterestAnalytics';
import getCookie from '../../../utils/getCookie';

import { BROWSER_FINGERPRINT_COOKIE_NAME } from '../../../constants/utils';
import { ENV } from '../../../constants/environments';
import { LIBRARY_IDS } from '../../../constants/api';

export default async function getFeaturedCollections(): Promise<HomepageFeaturedCollectionsData | AxiosError> {
  const baseUrl: string = ENV.api.baseURL;
  const useV2Endpoints = ENV.useV2ProductEndpoints;
  const { LIBRARY_ID_2D, LIBRARY_ID_3D } = LIBRARY_IDS;
  touchCookie();
  const browser_fingerprint = getCookie(BROWSER_FINGERPRINT_COOKIE_NAME);

  let collections2dUrl: string = `${baseUrl}/collections?library_id=${LIBRARY_ID_2D}`;
  let collections3dUrl: string = `${baseUrl}/collections?library_id=${LIBRARY_ID_3D}`;
  const collectionsPflUrl: string = `${baseUrl}/scenes`;

  if (useV2Endpoints) {
    collections2dUrl = collections2dUrl.replace('v1', 'v2');
    collections3dUrl = collections3dUrl.replace('v1', 'v2');
  }

  const collectionsParams: QueryParams = {
    order_by: 'position',
    desc: false,
    featured: true
  };
  if (browser_fingerprint) {
    collectionsParams.user_token = browser_fingerprint;
  }
  function fetchFeaturedCollection(collectionUrl: string) {
    return axios.get(collectionUrl, { params: collectionsParams })
  }

  const get2dCollectionsPromise = fetchFeaturedCollection(collections2dUrl);
  const get3dCollectionsPromise = fetchFeaturedCollection(collections3dUrl);
  const getPflCollectionsPromise = fetchFeaturedCollection(collectionsPflUrl);


  return Promise.all([get2dCollectionsPromise, get3dCollectionsPromise, getPflCollectionsPromise])
  .then(function(values: Array<GenericResponse<{ data: Array<CollectionResponse> }>>) {
    const collection2dResponse = values[0];
    const collection3dResponse = values[1];
    const collectionPflResponse = values[2];
    return {
      library2d: collection2dResponse?.data?.data.slice(0, 20),
      library3d: collection3dResponse?.data?.data.slice(0, 20),
      libraryPfl: collectionPflResponse?.data?.data.slice(0, 20),
    };
  })
  .catch(function(error: AxiosError) {
    return error;
  });
}
